import { render, staticRenderFns } from "./InputArea.vue?vue&type=template&id=0dd0953a&scoped=true&"
import script from "./InputArea.vue?vue&type=script&lang=ts&"
export * from "./InputArea.vue?vue&type=script&lang=ts&"
import style0 from "./InputArea.vue?vue&type=style&index=0&id=0dd0953a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd0953a",
  null
  
)

export default component.exports